/**
 * Types of Regex Patterns
 * @enum
 */
const Regex = {
  /**
   * Regex for pattern matching names.
   *
   * It allows names to start with letters or accented letter, and may contain
   * letters, hyphens, ampersands, single quotes, forward slashes, and spaces.
   * Names can be empty or consist of a single character.
   */
  NAMES: /^([A-Za-zÀ-ÿ][-&'\\/A-Za-zÀ-ÿ ]*)?$/,
  ACCOUNT_NUMBER: /^\d{10}$/,
  CARD_ACCOUNT: /^(?!05)\d{10}$/,
  CASH_ACCOUNT: /^05\d{8}$/,
  CARD_NUMBER: /^\d{16}$/,
  SECURE_CARD_NUMBER: /^\d{1} \d{9}$/,
  REGO_NUMBER: /^[A-Z0-9 ]{1,12}$/,
  SECURE_CARD_NUMBER_PARTIAL: /^\d ?\d{0,9}$/,
  CASH_ORDER_NUMBER: /^[a-zA-Z0-9]{10}$/,
  /**
   * Regex for pattern matching numbers zero or more times
   */
  ONLY_NUMBERS: /^[0-9]*$/,
  /**
   * Pattern matching numbers, optionally followed by 1 or 2 decimal numbers (Currency format)
   */
  CURRENCY: /^(?:\d+(\.\d{1,2})?)?$/,

  ALPHA: /^[a-zA-Z]*$/,
  ALPHA_SPACE: /^[a-zA-Z\s]*$/,
  ALPHA_SPACE_HYPHEN: /^[a-zA-Z\s-]*$/,
  ALPHA_NUM_SPACE_SPECIAL: /^[a-zA-Z0-9\s-&/\\']*$/,
  ALPHA_NUM_SPACE_SPECIAL2: /^[a-zA-Z0-9\s\-&/']*$/,
  ALPHA_NUM_SPACE_SPECIAL_CHARACTER: /^[a-zA-Z0-9\s!@#$%^&*()_+{}[\]:;"'<>,.?/~|\\-]*$/,
  ALPHA_NUM: /^[a-zA-Z0-9]*$/,
  ALPHA_NUM_SPACE: /^[a-zA-Z0-9\s]*$/,
  ALPHA_NUM_SPACE_HYPHEN: /^[a-zA-Z0-9\s-]*$/,
  EXPIRY_MONTH_YEAR: /^(0[1-9]|1[0-2])\/(\d\d)$/,
  POSTCODE: /^[0-9]{4}$/,
  LOCATION_NUMBER: /^000\d{5}$/,
  LOCATION_NUMBER_OPTIONAL: /^(000\d{5})*$/,
  LOCATION_NUMBER_PARTIAL: /^\d{5}$/,

  MOBILE: /^\+614[0-9]{8}$/,
  MOBILE_LANDLINE: /^(\+614|0[2,3,7,8])[0-9]{8}$/,

  REPORTS_ALPHA_NUM_SPACE_SPECIAL: /^[a-zA-Z0-9\s.,:;!?'"$&()-]*$/,

  SCHEDULED_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL: /^[a-zA-Z0-9\s&/\\',.:*()-]*$/,
  CARD_MAINTENANCE_ALPHA_NUM_SPACE_SPECIAL: /^[a-zA-Z0-9\s:&_$]*$/,
  PLASTIC_TYPE_ID: /^[A|C]_\d{3}$/,

  DRIVER_NAME: /^[a-zA-Z0-9\s-.()&/\\']*$/,

  CASH_CUSTOM_MESSAGE: /^[a-zA-Z0-9\s.,:;!?'"$&()-]*$/,
  CASH_DISCOUNT: /^\d+(\.\d{1,2})?$/,

  /**
   * Regex for pattern matching numbers with up to two decimal places.
   */
  NUM_WITH_OPTIONAL_DECIMAL: /^\d+(\.\d{1,2})?$/,
  EXPIRY_DATE_CARD_DETAILS: /^(0[1-9]|1[0-2]|[1-9])\/\d{2}$/,
};

export default Regex;
